var e={formLabel:"lds-form-label",requiredAsterisk:"lds-form-label--required-asterisk"};export{e as default};
